import { render, staticRenderFns } from "./ModifyPwd.vue?vue&type=template&id=4e13b096"
import script from "./ModifyPwd.vue?vue&type=script&lang=js"
export * from "./ModifyPwd.vue?vue&type=script&lang=js"
import style0 from "./ModifyPwd.vue?vue&type=style&index=0&id=4e13b096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports